import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { AuditType } from '../../../../models/audit-type.enum';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-type-view',
  standalone: true,
  imports: [
    NgIf,
    TranslocoDirective
  ],
  templateUrl: './type-view.component.html',
  styleUrl: './type-view.component.scss'
})
export class TypeViewComponent implements OnInit {
  @Output() selectedTypeChange = new EventEmitter<AuditType | undefined>();
  @Input() selectedType?: AuditType | undefined;
  @Input() public showErrorMessage: boolean = false;
  protected isValid: boolean = false;
  protected readonly auditType = AuditType;

  ngOnInit(): void {
    this.isValid = this.selectedType !== undefined;
  }

  protected selectType(type: AuditType | undefined): void {
    this.selectedType = type;
    this.isValid = this.selectedType !== undefined;
    this.selectedTypeChange.emit(type);
  }
}

